<template>
	<div class="c-zn-card c-zn-card--grouped">
		<h3 class="c-zn-card__bigtitle">{{ card.title }}</h3>

		<ul class="c-zn-card-grouped__list">
			<li v-for="form in card.forms">
				<a :href="form.url" class="c-zn-card-data" target="_blank">
					<div class="c-zn-card-datawrapper c-zn-card-datawrapper--auto c-zn-card-datawrapper--date">
						<span class="c-zn-card-data__date">{{ getDate(form.date) }}</span>
						<span class="c-zn-card-meta__code c-zn-card-meta__code--mobile">{{ form.code }}</span>
					</div>
					<div class="c-zn-card-datawrapper">
						<h3 class="c-zn-card__title c-zn-card__title--small">
							{{ form.title }}
						</h3>
						<span class="c-zn-card__meta">
							<span class="c-zn-card-meta__code c-zn-card-meta__code--desktop">
								{{ form.code }}
							</span>
							<svg class="icon icon-icon_download"><use xlink:href="#icon-icon_download"></use></svg>
						</span>
					</div>
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	props: {
		card: Object,
	},
	data() {
		return {};
	},
	methods: {
		getDate(datestring) {
			const date = new Date(datestring);
			return date.toLocaleDateString('en-GB', {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit',
			});
		},
	},
};
</script>
